import Modal from './Modal';

function DeleteConfirmModal({ isOpen, onClose, onConfirm, conversationTitle }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Conversation"
      size="small"
    >
      <p>Are you sure you want to delete this conversation?</p>
      <p><strong>"{conversationTitle || 'Untitled conversation'}"</strong></p>
      <p className="delete-warning">This action cannot be undone.</p>

      <div className="form-actions">
        <button
          className="btn btn-secondary"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={onConfirm}
        >
          Delete
        </button>
      </div>
    </Modal>
  );
}

export default DeleteConfirmModal;